function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React from 'react';
import { Grid, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import { useTranslation } from 'react-i18next';
var StyledLink = styled('a')(function (_ref) {
  var theme = _ref.theme;
  return {
    color: theme.palette.font.tertiary,
    textDecoration: 'none'
  };
});
var StyledGrid = styled(Grid)(function (_ref2) {
  var theme = _ref2.theme;
  return _defineProperty(_defineProperty({
    flexWrap: 'nowrap',
    '&': {
      '--figma-22-px': '1.375rem',
      '--figma-13-px': '0.8125rem'
    }
  }, theme.breakpoints.down('sm'), {
    display: 'none'
  }), '.MuiGrid-item', {
    display: 'flex',
    alignItems: 'center',
    whiteSpace: 'nowrap',
    flexWrap: 'nowrap',
    '&:not(:last-of-type)::after': {
      content: '"|"',
      color: theme.palette.grey['400'],
      fontSize: 'var(--figma-13-px)',
      marginLeft: 'var(--figma-22-px)',
      marginRight: 'var(--figma-22-px)'
    }
  });
});
var DesktopFooterItems = function DesktopFooterItems() {
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  return /*#__PURE__*/React.createElement(StyledGrid, {
    container: true
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true
  }, /*#__PURE__*/React.createElement(Typography, {
    color: "font.tertiary",
    variant: "body2"
  }, "\xA9 2022 Attuned")), /*#__PURE__*/React.createElement(Grid, {
    item: true
  }, /*#__PURE__*/React.createElement(StyledLink, {
    target: "_blank",
    href: t('URL_privacy_policy'),
    rel: "noreferrer"
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "body2"
  }, t('privacy')))), /*#__PURE__*/React.createElement(Grid, {
    item: true
  }, /*#__PURE__*/React.createElement(StyledLink, {
    target: "_blank",
    href: t('URL_terms'),
    rel: "noreferrer"
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "body2"
  }, t('terms')))));
};
export default DesktopFooterItems;